import React, { useState } from 'react';
import {
  COUNTRY_FILTER_ALL,
  COUNTRY_FILTER_FEATURED,
} from '../../config/constants';
import {
  getDisplayCountry,
  getCountryFlagImageUrl,
} from '../../data/countries';

const CountryFlag = ({ code, imgWidth = 20, emojiSize = "1.1rem", className = "" }) => {
  const key = String(code || "").toUpperCase();
  const iconStyle = { fontSize: Math.round(imgWidth * 0.75), color: "var(--primary)", width: imgWidth, textAlign: "center", flexShrink: 0 };
  if (key === COUNTRY_FILTER_ALL) {
    return <i className={`fas fa-globe ${className}`.trim()} style={iconStyle} aria-hidden="true" title="All countries" />;
  }
  if (key === COUNTRY_FILTER_FEATURED) {
    return <i className={`fas fa-earth-americas ${className}`.trim()} style={iconStyle} aria-hidden="true" title="Featured markets" />;
  }
  const meta = getDisplayCountry(code);
  const url = getCountryFlagImageUrl(code);
  const [imgFailed, setImgFailed] = useState(false);
  if (url && !imgFailed) {
    return (
      <img
        className={`country-flag-img ${className}`.trim()}
        src={url}
        alt=""
        width={imgWidth}
        height={Math.max(10, Math.round(imgWidth * 0.72))}
        loading="lazy"
        onError={() => setImgFailed(true)}
      />
    );
  }
  return <span className={className} style={{ fontSize: emojiSize, lineHeight: 1 }} aria-hidden="true">{meta.flag}</span>;
};

export default CountryFlag;
